import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  Address,
  Associate,
  ServiceAppointment as Appointment,
  Vehicle
} from '@quorum/models/xs-resource';
import { createFormGroupFromObject } from 'libs/sha-services/src/lib/createFormGroupFromObject';

@Component({
  selector: 'sha-create-service-appointment',
  templateUrl: './create-service-appointment.component.html',
  styleUrls: ['./create-service-appointment.component.scss'],
})
export class CreateServiceAppointmentComponent implements OnInit, OnChanges {
  @Input() associate: Associate;
  @Input() address: Address;
  @Input() vehicle: Vehicle;
  associateForm: FormGroup;
  addressForm: FormGroup;
  vehicleForm: FormGroup;
  appointmentForm: FormGroup;
  constructor() {}

  ngOnInit() {
    this.appointmentForm = createFormGroupFromObject(new Appointment());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.vehicle) {
      this.vehicleForm = createFormGroupFromObject(changes.vehicle);
    }
    if (changes.associate) {
      this.associateForm = createFormGroupFromObject(changes.associate);
    }
    if (changes.address) {
      this.addressForm = createFormGroupFromObject(changes.address);
    }
  }
}
